import ActionTypes from 'redux/ActionTypes';
import { gsap } from 'gsap';
import { toggleModal } from './modal';
import { findKey } from 'helper/utils';
import { getMilestone } from './user';

const directionMapping = {
	top: [1, 2, 3, 4, 5],
	right: [6, 7, 8, 9, 10],
	bottom: [10, 11, 12, 13, 14, 15],
	left: [16, 17, 18, 19, 20],
};

const settings = {
	foward: [3, 12, 16],
	backward: [6, 9, 19],
};

export const setDataGame = (key, data) => ({
	type: ActionTypes.SET_DATA_GAME,
	payload: {
		key,
		data,
	},
});

export const rollDice = (dice) => {
	return (dispatch) => {
		const timeline = gsap.timeline();
		const diceElement = document.querySelector('.dice');
		dispatch(setDataGame('onAnimation', true));
		timeline
			.to(diceElement, {
				/** Roll Dice effect */
				keyframes: [
					{
						rotate: '+=360',
						x: 0,
						y: -50,
						duration: 0.5,
					},
					{
						opacity: 1,
						rotation: '+=360',
						x: 0,
						y: -25,
						duration: 0.5,
					},
					{
						opacity: 0.5,
						rotation: '+=180',
						x: 0,
						y: 0,
						duration: 0.25,
					},
					{
						rotation: 0,
						backgroundImage: `url(${process.env.REACT_APP_CDN_URL}img_dice_${dice}.png)`,
						opacity: 1,
						x: 0,
						y: 0,
					},
				],
			})
			.set(diceElement, {
				/** Set Dice */
				x: 0,
				y: 0,
				backgroundImage: `url(${process.env.REACT_APP_CDN_URL}img_dice_${dice}.png)`,
				keyframes: [],
			})
			.then(() => {
				dispatch(doAnimation(dice));
			});
	};
};

export const doAnimation = (movement, backward = false, log = 'dice') => {
	return (dispatch, getState) => {
		const position = getState().game.position;
		const modifier = getState().game.modifier;

		const endPosition = normalizePosition(
			position + (backward ? -movement : movement)
		);
		const pawnElement = document.querySelector('.pawn');
		const keyframes = [];
		// console.log(`animation run from : ${log}`);
		// console.log(`running animation pos : ${position}`);
		dispatch(setDataGame('onAnimation', true));
		for (let i = 1; i <= movement; i++) {
			const tempMovement = position + (backward ? -i : i);
			const [x, y, flip, newMovement] = findPosition(tempMovement);
			/** Bounce Effect */
			keyframes.push({
				scaleX: flip ? -1 : 1,
				scaleY: 0.6,
				duration: 0.5,
			});
			/** Move Effect */
			keyframes.push({
				scaleY: 1,
				scaleX: flip ? -1 : 1,
				x: x,
				y: y,
				duration: 0.25,
				onComplete: () => {
					// console.log(`current jump pos : ${newMovement}`);
					dispatch(setDataGame('position', newMovement));
					/** Check the destination move & the current move*/
					if (isPositionLast(tempMovement) && isPositionStart(newMovement)) {
						// console.log('--New Lap--');
						let lap = getState().game.lap;
						dispatch(setDataGame('lap', ++lap));
                        dispatch(getMilestone());
					}
				},
			});
		}
		gsap.to(pawnElement, {
			keyframes: keyframes,
			onStart: () => {
				console.log(`end position : ${endPosition}`);
				dispatch(setDataGame('endPosition', endPosition));
			},
			onComplete: () => {
				const moveBackward = settings.backward.includes(endPosition);
				const moveFoward = settings.foward.includes(endPosition);
				if (moveBackward || moveFoward) {
					/** if pawn hits move modifier */
					// console.log(`doing move modifier modifier : ${modifier}`);
					dispatch(
						doAnimation(modifier, moveBackward, 'move modifier')
					); /** Recursion the animation */
				} else {
					// console.log(`end animation`);
					setTimeout(() => {
						dispatch(setDataGame('endPosition', -1));
					}, 250);
					dispatch(setDataGame('onAnimation', false));
					dispatch(toggleModal('ModalPrize', true));
				}
			},
		});
	};
};

const isPositionStart = (position) => position === 1;
const isPositionLast = (position) => position > 20;

const normalizePosition = (position) => {
	if (isPositionLast(position)) return position - 20;
	return position;
};

const findDirection = (position) => findKey(directionMapping, position);

export const findPosition = (position) => {
	let x = 0;
	let y = 0;
	let flip = false;
	const newPosition = normalizePosition(position);
	const direction = findDirection(position);
	const child = document
		.querySelector(`.tiles-${newPosition}`)
		.getBoundingClientRect();
	const parent = document
		.querySelector(`.board-wrapper`)
		.getBoundingClientRect();
	y = child.bottom - parent.bottom;
	x = child.left - parent.left;
	if (direction === 'bottom' || direction === 'left') flip = true;
	return [x, y, flip, newPosition];
};
